// extracted by mini-css-extract-plugin
export default {"cancelBtn":"SubmitCancelButtons_cancelBtn__4Bk36","yesBtn":"SubmitCancelButtons_yesBtn__TV5SI"};